import SessionContext from "modules/Session/SessionContext";
import { useEffect } from "react";
import useAppStore from "store/store";

interface SessionProps {
    children: React.ReactNode;
}

const SessionProvider = ({ children }: SessionProps) => {

    const areAllowedToPostSessionData = () => {

        // Always get the latest
        const analyticsEnabled = useAppStore.getState().analyticsEnabled
        const sessionId = useAppStore.getState().sessionId;
        const serverUrl = useAppStore.getState().serverUrl;

        return analyticsEnabled && sessionId && serverUrl;
    }

    const postSessionData = async ({ event, data }: { event: string, data: any }) => {

        // Always get the latest
        const sessionId = useAppStore.getState().sessionId;
        const serverUrl = useAppStore.getState().serverUrl;
	    const isFocused = useAppStore.getState().isFocused;

        // Check to be sure!
        if( !areAllowedToPostSessionData() || !isFocused ) {
            return
        }

        try {
            const response = await fetch( `${serverUrl}/api/guest`, {
                method: 'POST',
                headers: {
                    'Session-Id': sessionId,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    event: event,
                    data: data,
                }),
            });
        } catch (error) {
            console.warn('Error posting session data:', error);
        }
    }

    useEffect(() => {
        // Post session data every 30 seconds
        const interval = setInterval(() => {

            const visibleGroups = useAppStore.getState().visibleGroups;

            postSessionData( visibleGroups?.length > 0 ? {
                data: {
                    visible: visibleGroups,
                }
            } : {} );
        }, 10 * 1000); // 10 seconds

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
		const handleBeforeUnload = (event) => {

            // postSessionData({ event: 'page_close' })

			// Show a warning dialog
			// event.preventDefault();
			event.returnValue = ''; // Required for Chrome
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, []);

    return (
        <SessionContext.Provider 
            value={{ 
                postSession: postSessionData 
            }}>

            { children }
        </SessionContext.Provider>
    )
}

export default SessionProvider;